import type { FormValues } from "@/widgets/classic-form/form";
import { GENDER_FIELD_KEY, genderDataModelToFormValue } from "@/entities/data-model/genderValue";
import type { OtherFieldGroup } from "@/entities/form-metadata";

export const populateOtherFields = ({
    fieldGroup,
    dataModel,
    formValuesFieldsData,
    matchAllTermsExactly,
    isEditForm,
}: {
    fieldGroup: OtherFieldGroup;
    dataModel: FormValues;
    formValuesFieldsData: FormValues["fields"];
    matchAllTermsExactly: boolean;
    isEditForm?: boolean;
}) => {
    const { fields: fieldsFromDataModel } = dataModel;

    fieldGroup.others.forEach((otherItem) => {
        const { relation, assertion, eventType: eventName, fields } = otherItem;
        const fieldAccessor = `${relation}${eventName}${assertion}`;
        // @ts-ignore FIXME
        const isExactnessEnabled = fields[0].features.showExactness ?? true;

        const isExactEnabledValue = isEditForm
            ? (fieldsFromDataModel[fieldAccessor]?.isExact ?? false)
            : matchAllTermsExactly
              ? true
              : (fieldsFromDataModel[fieldAccessor]?.isExact ?? false);

        const dataModelValue = fieldsFromDataModel[fieldAccessor]?.value ?? "";

        formValuesFieldsData[fieldAccessor] = {
            value: fieldAccessor === GENDER_FIELD_KEY ? genderDataModelToFormValue(dataModelValue) : dataModelValue,
            relation,
            eventName,
            assertion,
            isExact: isExactnessEnabled ? isExactEnabledValue : false,
        };
    });
};
